module.exports = __webpack_public_path__ + "static/media/panelova_diskusia.368eed6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/panelova_diskusia.jpg
// module id = 563
// module chunks = 0